export default __webpack_public_path__ + "static/media/four.7513074c.jpg";